import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {BartenderServer} from './BartenderUtil';
import {LabelPrintingMethod} from './LabelPrintingConstants';

export function printLabels(
  itemIds: Array<string>,
  labelTemplateId: string,
  printerId: string,
  copies: number = 1
): JQueryPromise<{}> {
  return TaskRunner.postJSON({
    url: '/1/api/label-printing:print-labels',
    data: {
      itemIds,
      labelTemplateId,
      printerId,
      copies,
    },
  });
}

export function logPrint(
  itemIds: Array<string>,
  labelTemplateName: string,
  printerName: string,
  copies: number = 1
): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/label-printing:log-print',
    data: {itemIds, labelTemplateName, printerName, copies},
  });
}

export interface GetFilledLabelTemplateResponse {
  zpl: string;
}

export function getFilledLabelTemplate(
  itemId: string,
  labelTemplateId: string
): JQueryPromise<GetFilledLabelTemplateResponse> {
  return net.postJSON({
    url: '/1/api/label-printing:get-filled-label-template',
    data: {
      itemId,
      labelTemplateId,
    },
  });
}

export interface BulkGetFilledLabelTemplateResponse {
  printPayloads: Array<string>;
}

export function bulkGetFilledLabelTemplate(
  itemIds: Array<string>,
  labelTemplateId: string
): Promise<BulkGetFilledLabelTemplateResponse> {
  return net.postJSONPromise({
    url: '/1/api/label-printing:bulk-get-filled-label-template',
    data: {
      itemIds,
      labelTemplateId,
    },
  });
}

export function putLabelPrintingConfig(payload: {
  labelPrintingMethod: LabelPrintingMethod;
  bartenderServers: Array<BartenderServer>;
  enableLabelTemplatePreview: boolean;
}): Promise<void> {
  return net.putJSONPromise({
    url: '/1/api/label-printing-config',
    data: payload,
  });
}
